import { lazy } from "react";
import { RouteConfig } from "../../types/RouteConfig";

export const starterPageRoute: RouteConfig<'with-page'> = {
    name: 'Starter',
    path: '/starter',
    page: lazy(() => import('.')),
    flags: ['no-menu-item'],
}